const BASE = process.env.REACT_APP_API_URL || window.location.origin;

function headers(token) {
  const h = { "Content-Type": "application/json" };
  if (token) h["Authorization"] = `Bearer ${token}`;
  return h;
}

async function req(method, path, body, token) {
  const opts = { method, headers: headers(token) };
  if (body && !(body instanceof FormData)) opts.body = JSON.stringify(body);
  if (body instanceof FormData) {
    // Remove Content-Type so browser sets multipart boundary
    delete opts.headers["Content-Type"];
    opts.body = body;
  }
  const res = await fetch(`${BASE}/api${path}`, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Erro desconhecido");
  return data;
}

export const api = {
  // Auth
  login:      (username, password, slug) => req("POST", "/auth/login", { username, password, slug }),
  me:         (token)                    => req("GET",  "/auth/me", null, token),

  // Agenda (public)
  getAgenda:  (slug)                     => req("GET",  `/agenda/${slug}`),

  // Events (admin)
  addEvent:   (slug, ev, token)          => req("POST", `/agenda/${slug}/events`, ev, token),
  editEvent:  (slug, id, ev, token)      => req("PUT",  `/agenda/${slug}/events/${id}`, ev, token),
  deleteEvent:(slug, id, token)          => req("DELETE",`/agenda/${slug}/events/${id}`, null, token),
  syncIcal:  (slug, token)               => req("POST", `/agenda/${slug}/integration/sync`, null, token),

  // Master admin
  getAgendas: (token)                    => req("GET",  "/admin/agendas", null, token),
  createAgenda:(data, token)             => req("POST", "/admin/agendas", data, token),
  updateAgenda:(id, data, token)         => req("PUT",  `/admin/agendas/${id}`, data, token),
  deleteAgenda:(id, token)               => req("DELETE",`/admin/agendas/${id}`, null, token),
  addUser:    (agendaId, data, token)    => req("POST", `/admin/agendas/${agendaId}/users`, data, token),
  deleteUser: (userId, token)            => req("DELETE",`/admin/users/${userId}`, null, token),
  resetPass:  (userId, password, token)  => req("PUT",  `/admin/users/${userId}/password`, { password }, token),
};
